export interface ComplianceRow {
  name: string;
  status: string;
  renewal: string;
  cover?: string;
}

export const COMPLIANCE_ROWS: ComplianceRow[] = [
  { name: "MCS Certification (Solar PV & ASHP)", status: "Active", renewal: "" },
  { name: "TrustMark Registration", status: "Active", renewal: "" },
  { name: "PAS 2030 (Retrofit)", status: "Active", renewal: "" },
  { name: "Gas Safe Registration", status: "Active", renewal: "" },
  { name: "Public / Product Liability Insurance", status: "Active", renewal: "", cover: "£5,000,000" },
  { name: "Employers' Liability Insurance", status: "Active", renewal: "", cover: "£10,000,000" },
  { name: "Professional Indemnity", status: "Active", renewal: "", cover: "£2,000,000" },
  { name: "Insurance-Backed Guarantee Provider", status: "Active", renewal: "" },
  { name: "CHAS / SafeContractor (or equivalent)", status: "On request", renewal: "" },
  { name: "ISO 9001 / 14001 / 45001", status: "On request", renewal: "" },
];

export const SOLAR_COMPLIANCE_ROWS: ComplianceRow[] = [
  { name: "MCS Certification (PV)", status: "Active", renewal: "" },
  { name: "TrustMark Registration", status: "Active", renewal: "" },
  { name: "Public / Product Liability Insurance", status: "Active", renewal: "", cover: "£5,000,000" },
  { name: "Employers' Liability Insurance", status: "Active", renewal: "", cover: "£10,000,000" },
  { name: "Professional Indemnity", status: "Active", renewal: "", cover: "£2,000,000" },
  { name: "Insurance-Backed Guarantee Provider", status: "Active", renewal: "" },
  { name: "CHAS / SafeContractor (or equivalent)", status: "On request", renewal: "" },
  { name: "ISO 9001 / 14001 / 45001", status: "On request", renewal: "" },
];
